/**
 * The tracked per-recipient delivery vocabulary: the numeric `deliveryStatus`
 * codes the API's messageEvents rollup writes. Never the legacy `status`
 * column, which says nothing about whether a message actually arrived.
 *
 * These live in their own file because three places reason about the same
 * codes — the badge that renders them, the message timeline that decides what
 * a salon can do about them, and the campaign report that maps the server's
 * outcome ladder back onto them. While the numbers were private to the badge,
 * the other two had no choice but to restate them as bare literals, which is
 * how a "single source of truth" ends up with three copies.
 */
export const STATUS_QUEUED = 0;
export const STATUS_DELIVERED = 1;
export const STATUS_BOUNCED = 2;
export const STATUS_SPAM = 3;
export const STATUS_SENT = 4;
export const STATUS_DEFERRED = 5;
export const STATUS_BLOCKED = 6;
export const STATUS_SENT_UNTRACKED_FATE = 7;
export const STATUS_REJECTED = 8;
